import { ChangeDetectionStrategy, Component, inject, OnDestroy } from "@angular/core";

import { Store } from "@ngxs/store";
import { TagType } from "@vp/models";
import { filterNullMap } from "@vp/shared/operators";
import * as TagManagerActions from "@vp/tag-manager/data-access/tag-manager-state";
import { TagManagerState } from "@vp/tag-manager/data-access/tag-manager-state";
import { Observable, Subject } from "rxjs";

@Component({
  selector: "vp-tag-type-menu-selector",
  templateUrl: "./tag-type-menu-selector.component.html",
  styleUrls: ["./tag-type-menu-selector.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class TagTypeMenuSelectorComponent implements OnDestroy {
  private readonly store = inject(Store);

  filteredTagTypes$: Observable<TagType[]> = inject(Store).select(TagManagerState.tagTypes);
  selectedTagTypes$: Observable<TagType[]> = inject(Store).select(TagManagerState.selectedTagTypes);
  selectedTagType$: Observable<TagType | null> = inject(Store).select(
    TagManagerState.selectedTagType
  );

  private readonly destroy$ = new Subject<void>();

  editingTagType$: Observable<TagType | null> = this.selectedTagType$.pipe(filterNullMap());

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  tagTypeSelected = (tagType: TagType) => {
    this.store.dispatch(new TagManagerActions.SelectTagType(tagType.tagTypeId));
    this.clearState();
  };

  removeSelected = (tagType: TagType) => {
    this.store.dispatch(new TagManagerActions.UnselectTagType(tagType.tagTypeId));
    this.clearState();
  };

  clearState() {
    this.store.dispatch(
      new TagManagerActions.UpdateState({
        tagTypeSearch: ""
      })
    );
  }
}
